import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Alert } from 'shared/ui'
import { KnowledgeBaseIndexationStatusAlert } from 'widgets/KnowledgeBase'
import { useKnowledgeBaseViewContext } from 'pages/settings/pages/knowledgeBase/context/knowledgeBaseViewContext'
import { INDEXATION_RETRY } from 'pages/settings/pages/knowledgeBase/lib/constants'
import styles from './styles.module.scss'

export const KnowledgeBaseNotifications = observer(() => {
  const {
    isPageSpinnerShown,
    notificationStore: { notifications, clearNotification },
    knowledgeBaseStore: { knowledgeBase },
    documentsStore: {
      isEmpty,
      onRetryIndexation,
      documentIdsToRetry,
      isDocumentsIndexingRetryLoading,
    },
  } = useKnowledgeBaseViewContext()

  const isNotificationShown = !!knowledgeBase && !isPageSpinnerShown && !isEmpty

  return (
    <div
      className={classNames(styles.alertContainer, {
        [styles.emptyView]: isEmpty,
      })}
    >
      {isNotificationShown && <KnowledgeBaseIndexationStatusAlert knowledgeBase={knowledgeBase} />}
      {!!documentIdsToRetry.length && (
        <Alert
          item={{
            type: 'error',
            desc: INDEXATION_RETRY,
          }}
          rightActions={[
            {
              variant: 'button',
              type: 'primary',
              disabled: isDocumentsIndexingRetryLoading,
              text: 'Try again',
              onClick: () => onRetryIndexation(documentIdsToRetry),
            },
          ]}
        />
      )}
      {notifications.map((notification) => (
        <Alert
          key={notification.id}
          item={{
            type: notification.type,
            desc: notification.message,
          }}
          onClose={() => clearNotification(notification.id)}
        />
      ))}
    </div>
  )
})
